import { CwtApiEntity, CwtModel, CwtProp, CwtSubCrudContract } from "@cawita/core-front/api";
import { Area } from "./area.model";

@CwtModel({ name: 'area-price' })
@CwtSubCrudContract({ parentPath: 'area', subPath: 'area-price', parent: Area })
export class AreaPrice extends CwtApiEntity {
    @CwtProp() startDate: number;
    @CwtProp() endDate: number;
    @CwtProp() price: number;
}